import {
  createSlice,
  isFulfilled,
  isRejectedWithValue,
  isPending,
  PayloadAction,
} from '@reduxjs/toolkit'
import { getEpisodeDetails, getCourseDetails, moveEpisodeToTheTopOfTimeline } from './thunks'
import { ItemDetailsStateType } from './types'

const initialState: ItemDetailsStateType = {
  expandedItemId: '',
  details: [],
  isCourseCompleted: false,
  dates: [],
  availableFrom: '',
  loadingItemId: null,
  loadingActionButtonId: null,
  isLoading: false,
  error: null,
  success: false,
}

const itemDetailsSlice = createSlice({
  name: 'item-details',
  initialState,
  reducers: {
    setLoadingActionButtonId: (state, action: PayloadAction<string>) => {
      state.loadingActionButtonId = action.payload
    },

    setExpandedItemId: (state, action: PayloadAction<string>) => {
      state.expandedItemId = action.payload
    },

    collapseItem: (state) => {
      state.expandedItemId = initialState.expandedItemId
    },

    setLoadingItemId: (state, action: PayloadAction<string>) => {
      state.loadingItemId = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getEpisodeDetails.fulfilled, (state, action) => {
      state.details = action.payload.episodeDetails
      state.isCourseCompleted = action.payload.isCourseCompleted
      state.isLoading = false
    })

    builder.addCase(getCourseDetails.fulfilled, (state, action) => {
      state.details = action.payload.episodesDetails
      state.dates = action.payload.episodeDates
      state.availableFrom = action.payload.availableFrom
    })

    builder.addMatcher(isFulfilled(getEpisodeDetails, getCourseDetails), (state) => {
      state.success = true
      state.error = null
      state.loadingItemId = null
      state.isLoading = false
    })

    builder.addMatcher(isPending(getEpisodeDetails, getCourseDetails), (state) => {
      state.error = null
      state.success = false
    })
    builder.addMatcher(isFulfilled(moveEpisodeToTheTopOfTimeline), (state) => {
      state.loadingActionButtonId = null
    })
    builder.addMatcher(
      isRejectedWithValue(getEpisodeDetails, getCourseDetails, moveEpisodeToTheTopOfTimeline),
      (state, action) => {
        state.error = {
          message: action.payload.message,
        }
        state.loadingItemId = null
        state.loadingActionButtonId = null
        state.success = false
        state.isLoading = false
      }
    )
  },
})

export const itemDetailsReducer = itemDetailsSlice.reducer
export const {
  setExpandedItemId,
  collapseItem,
  setLoadingItemId,
  setLoadingActionButtonId,
  setIsLoading,
} = itemDetailsSlice.actions
